import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  DatePicker,
  Select,
  Checkbox,
  Radio,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DownOutlined } from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { getModifyPageSubscriptionTopic } from "hooks/MQTTConstants";
import { pushNotification } from "utils/notifications";
import {
  VALIDATE_SCHEDULE,
  DELETE_SCHEDULE,
  ENCRYPT_TOKEN,
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import TimePicker from "utils/datepicker";
import Geocode from "react-geocode";
import { getFriendUserInfo } from "utils/chatUtils";

Geocode.setApiKey("AIzaSyDgNagv_ozKWc6IQ75Ol4cH8fxdntOaW6M");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const { Option } = Select;

const { TextArea } = Input;

const AddEventModal: FC<{
  onClose: () => void;
  eventObj?: any;
  socket?: ISocket;
  id?: any;
  mode?: any;
  message?: any;
}> = (props) => {
  const { onClose, eventObj, socket, id, mode, message } = props;
  const { selectedItem, allUsers } = useSelector((state: any) => state.search);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [scheduleExist, setScheduleExist] = useState<boolean>(false);

  // const { scheduleExist } = useSelector((state: RootState) => state.auth);

  const [event, setEvent] = useState<any>({
    title: "",
    repeat: false,
    repeatAfter: 1,
    repeatFrequency: "day",
    repeatEnds: "never",
    repeatUntil: undefined,
    date: undefined,
    time: undefined,
    notifyTime: undefined,
    description: "",
    location: {
      attributes: {
        title: undefined,
        address: undefined,
      },
      coordinates: undefined,
    },
  });

  const { getLocalStorageItem } = useLocalStorageService();

  const updateEvent = (key: keyof EventInfo, value: ValueOf<EventInfo>) => {
    setEvent((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();
  const handleOk = () => {
    const data = { ...event };
    if (data.date) {
      data.date = new Date(event.date).getTime();
    }
    if (data.time) {
      data.time = new Date(event.time).getTime();
    }
    if (data.notifyTime) {
      data.notifyTime = new Date(event.notifyTime).getTime();
    }
    if (data.repeatUntil) {
      data.repeatUntil = new Date(event.repeatUntil).getTime();
    }

    const tempDate = new Date(event.date);
    const tempTime = new Date(event.time);

    tempDate.setHours(tempTime.getHours());
    tempDate.setMinutes(tempTime.getMinutes());

    data.dateTime = tempDate.getTime();
    delete data.date;
    delete data.time;

    if (!data.repeat) {
      data.repeatAfter = undefined;
      data.repeatFrequency = undefined;
      data.repeatUntil = undefined;
    } else if (data.repeatEnds === "never") {
      data.repeatUntil = undefined;
    }

    delete data.repeatEnds;

    console.log("data here", data);

    let edit = undefined;
    if (mode === "edit" && message) {
      edit = {
        id: message.id,
        originalCreatedAt: message.originalCreatedAt,
        originalPageMessageId: message.originalPageMessageId,
      };
    }
    console.log("mode", mode, data, edit);

    dispatch({
      type: "SEND_MESSAGE",
      payload: { message: event.title, type: "event", data, edit },
    });

    setIsModalVisible(false);
    onClose && onClose();
  };

  const reverseGeocode = (marker: any) => {
    Geocode.fromLatLng(marker.coordinates.lat, marker.coordinates.long).then(
      (response) => {
        console.log("response here", response);

        updateEvent("location", {
          attributes: {
            ...marker.attributes,
            label: marker.attributes.address,
            value: response?.results?.[0],
          },
          coordinates: marker.coordinates,
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  useEffect(() => {
    if (eventObj) {
      const tempEvent = { ...eventObj };
      if (tempEvent.dateTime) {
        tempEvent.date = moment(tempEvent.dateTime).format(
          "MM/DD/YYYY HH:mm:ss"
        );
        tempEvent.time = moment(tempEvent.dateTime).format(
          "MM/DD/YYYY HH:mm:ss"
        );
      }
      if (tempEvent.notifyTime) {
        tempEvent.notifyTime = moment(tempEvent.notifyTime).format(
          "MM/DD/YYYY HH:mm:ss"
        );
      }
      if (tempEvent.repeatUntil) {
        tempEvent.repeatEnds = "on";
        tempEvent.repeatUntil = moment(tempEvent.repeatUntil).format(
          "MM/DD/YYYY HH:mm:ss"
        );
      } else {
        tempEvent.repeatEnds = "never";
      }

      if (tempEvent?.location?.coordinates) {
        reverseGeocode(tempEvent.location);
      }

      setEvent(tempEvent);
      console.log("temp event here", tempEvent);
    }
    // if (id) {
    //   dispatch(VALIDATE_SCHEDULE({ eventId: id }));
    // }
  }, []);

  // const addToCalendar = () => {

  // };

  const exportToGoogleCalendar = (event) => {
    const baseUrl = "https://calendar.google.com/calendar/render";
    const queryParams = new URLSearchParams({
      action: "TEMPLATE",
      text: event.title, // Event title
      dates: `${event.startDate}/${event.endDate}`, // Start and end date in YYYYMMDDTHHmmssZ format
      details: event.description, // Event details
      location: event.location, // Event location
    }).toString();
    window.open(`${baseUrl}?${queryParams}`, "_blank");
  };

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const generateRecurringDates = (event) => {
    const {
      dateTime,
      repeat,
      repeatAfter,
      repeatEnds,
      repeatFrequency,
      repeatUntil,
    } = event;

    if (!repeat) return [moment(dateTime).format("YYYYMMDDTHHmmssZ")]; // Return only the start date if no repeat

    const recurrence = [];
    const startDate = moment(dateTime);
    let currentDate = startDate.clone();

    if (repeatEnds === "never") {
      // Generate 10 occurrences for demonstration
      for (let i = 0; i < 10; i++) {
        recurrence.push(currentDate.format("YYYYMMDDTHHmmssZ"));
        currentDate.add(parseInt(repeatAfter), repeatFrequency);
      }
    } else if (repeatEnds === "on") {
      const endDate = moment(repeatUntil, "MM/DD/YYYY HH:mm:ss");
      while (currentDate.isSameOrBefore(endDate)) {
        recurrence.push(currentDate.format("YYYYMMDDTHHmmssZ"));
        currentDate.add(parseInt(repeatAfter), repeatFrequency);
      }
    }

    return recurrence;
  };

  const getVideoUrl = () => {
    return new Promise((resolve, reject) => {
      // const user = allUsers?.find(
      //   (obj) => obj.id === localStorage.getItem("RID")
      // );
      const livekitUrl = `${process.env.REACT_APP_VIDEO_URI}?pageId=${selectedItem?.pageId}&u=${localStorage.getItem("RID")}&o=${localStorage.getItem("selectedOrg") || "cudb-live"}&metadata=${localStorage.getItem("RID")}`
      resolve(livekitUrl);
      // dispatch(
      //   ENCRYPT_TOKEN({
      //     data: {
      //       payload: JSON.stringify({
      //         userId: localStorage.getItem("RID"),
      //         userBeamId: user?.beamId,
      //         connectionId: `${localStorage.getItem("CID")}`,
      //         pageId: selectedItem?.pageId,
      //         pageTitle:
      //           selectedItem?.persistent?.static?.metadata?.title ||
      //           (selectedItem?.persistent?.static?.metadata?.type ===
      //             "friend" &&
      //           getFriendUserInfo(
      //             allUsers,
      //             selectedItem?.persistent?.static?.metadata?.members?.users
      //           )?.beamId
      //             ? getFriendUserInfo(
      //                 allUsers,
      //                 selectedItem?.persistent?.static?.metadata?.members?.users
      //               )?.beamId
      //             : `Page ${selectedItem?.pageId}`),
      //       }),
      //     },
      //     callback: (token) => {
      //       resolve(
      //         `${process.env.REACT_APP_VIDEO_URI}/room/${token.encryptedPayload}`
      //       );
      //     },
      //   })
      // );
    });
  };

  return (
    <Modal
      title={eventObj ? `Event information` : "Add Event"}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row>
        <Col span={24}>
          <Input
            value={event.title}
            onChange={(e) => updateEvent("title", e.target.value)}
            placeholder="Event Title"
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col span={24}>
          {/* <Select className="w-full" placeholder="Profile" options={[]} /> */}
          <TextArea
            autoSize={{ minRows: 4, maxRows: 6 }}
            placeholder="Description"
            value={event.description}
            onChange={(e) => {
              updateEvent("description", e.target.value);
            }}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col span={12} className="pr-2">
          <div className="datetime-item">
            <img src="/images/date.png" />
            <DatePicker
              value={
                event.date
                  ? moment(event.date, "MM/DD/YYYY HH:mm:ss")
                  : undefined
              }
              onChange={(date: moment.Moment | null) => {
                updateEvent("date", date?.format("MM/DD/YYYY HH:mm:ss"));
              }}
              placeholder="Date"
              suffixIcon={<DownOutlined />}
            />
          </div>
        </Col>
        <Col span={12} className="pl-2">
          <div className="datetime-item">
            <img src="/images/time.png" />
            <TimePicker
              name="time"
              value={
                event.time
                  ? moment(event.time, "MM/DD/YYYY HH:mm:ss")
                  : undefined
              }
              onChange={(time) => {
                updateEvent(
                  "time",
                  moment(time)?.format("MM/DD/YYYY HH:mm:ss")
                );
              }}
            />
          </div>
        </Col>
      </Row>

      <Row className="mt-3">
        <Checkbox.Group
          options={["Repeat every"]}
          // defaultValue={[]}
          onChange={(values) => {
            updateEvent("repeat", values.indexOf("Repeat every") !== -1);
          }}
          value={event.repeat ? ["Repeat every"] : []}
        />
      </Row>
      {event.repeat && (
        <React.Fragment>
          <Row className="mt-1">
            <Col span={12} className="pr-2">
              <Input
                value={event.repeatAfter}
                onChange={(e) => {
                  updateEvent("repeatAfter", e.target.value);
                }}
                type="number"
                min={1}
              ></Input>
            </Col>
            <Col span={12} className="pl-2">
              <div className="datetime-item prefix-select-wrapper">
                <img src="/images/refresh.png" />
                <Select
                  value={event.repeatFrequency}
                  className="w-full"
                  placeholder="Repeat"
                  onChange={(values) => {
                    updateEvent("repeatFrequency", values);
                  }}
                  // mode="multiple"
                >
                  <Option value="day">day</Option>
                  <Option value="week">week</Option>
                  <Option value="month">month</Option>
                </Select>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col span={24}>
              <span className="ant-checkbox-wrapper">Ends</span>
            </Col>
            <Radio.Group
              value={event.repeatEnds}
              onChange={(e) => {
                updateEvent("repeatEnds", e.target.value);
              }}
              className="plain-radios"
            >
              <Radio value={"never"} className="green-radio">
                Never
              </Radio>
              <Radio value={"on"} className="green-radio">
                On
              </Radio>
            </Radio.Group>

            {event.repeatEnds === "on" && (
              <div className="datetime-item mt-1">
                <DatePicker
                  value={
                    event.repeatUntil
                      ? moment(event.repeatUntil, "MM/DD/YYYY HH:mm:ss")
                      : undefined
                  }
                  onChange={(date: moment.Moment | null) => {
                    updateEvent(
                      "repeatUntil",
                      date?.format("MM/DD/YYYY HH:mm:ss")
                    );
                  }}
                  placeholder="Date"
                  suffixIcon={<DownOutlined />}
                />
              </div>
            )}
          </Row>
        </React.Fragment>
      )}

      <Row className="mt-3">
        <Col span={12} className="pr-2">
          <div className="datetime-item">
            <img src="/images/warning.png" />
            <TimePicker
              name="Notify Time"
              value={
                event.notifyTime
                  ? moment(event.notifyTime, "MM/DD/YYYY HH:mm:ss")
                  : undefined
              }
              onChange={(time) => {
                updateEvent(
                  "notifyTime",
                  moment(time)?.format("MM/DD/YYYY HH:mm:ss")
                );
              }}
            />
          </div>
        </Col>
        <Col span={12} className="pl-2">
          <Select
            value={event.notifyVia}
            className="w-full"
            placeholder="Notify via"
            onChange={(values) => {
              updateEvent("notifyVia", values);
            }}
            options={[
              { label: "Push", value: "push" },
              { label: "SMS", value: "sms" },
              { label: "Email", value: "email" },
            ]}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <div className="datetime-item prefix-select-wrapper">
            <img src="/images/location.png" />

            <GooglePlacesAutocomplete
              autocompletionRequest={{}}
              selectProps={{
                value: event?.location?.attributes?.value?.place_id
                  ? event?.location?.attributes
                  : undefined,
                onChange: (place: any) => {
                  console.log("place here", place);

                  if (place?.value?.place_id) {
                    geocodeByPlaceId(place.value.place_id)
                      .then((results) => {
                        if (results[0].geometry) {
                          let location = {
                            attributes: {
                              ...place,
                              address: place.label,
                            },
                            coordinates: {
                              lat: results[0].geometry.location.lat(),
                              long: results[0].geometry.location.lng(),
                            },
                          };
                          updateEvent("location", location);
                        }
                      })
                      .catch((error) => console.error(error));
                  } else {
                    updateEvent("location", undefined);
                  }
                },
                isClearable: true,
                placeholder: "Search map",
                styles: {
                  input: (provided: any) => ({
                    ...provided,
                    fontFamily: "Nunito-Regular",
                  }),
                  control: () => ({
                    backgroundColor: "hsl(218deg 33% 95%)",
                    display: "flex",
                  }),
                  container: (provided, state) => ({
                    ...provided,
                    width: "100%",
                  }),
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "#000",
                    fontSize: 16,
                    padding: 8,
                  }),
                  singleValue: (provided, state) => ({
                    ...provided,
                    color: "#000",
                    fontSize: 16,
                    padding: 8,
                  }),
                },
              }}
              apiKey={"AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"}
            />
          </div>
          {/* } */}
        </Col>
      </Row>
      {!eventObj || mode === "edit" ? (
        <Row className="action-grp mt-5">
          <Col span={14} className="pr-2">
            <Button
              className="beam-btn green-btn cover w-full"
              onClick={handleOk}
            >
              {"Save"}
            </Button>
          </Col>
          <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      ) : (
        <Row className="action-grp mt-5">
          {scheduleExist === false && (
            <Col span={24} className="">
              <Button
                className="beam-btn green-btn cover w-full"
                onClick={async () => {
                  // eventObj.eventId = `${id}${localStorage.getItem('RID')}`;
                  // sendPageUpdateEvent('addEventScheduler', eventObj);

                  // pushNotification(
                  //   "Event added to calendar",
                  //   "success",
                  //   'TOP_CENTER',
                  //   1000
                  // );

                  // handleCancel();
                  const meetingUrl = await getVideoUrl();
                  const tempEvent = { ...eventObj };
                  const obj = {
                    title: event.title,
                    startDate: moment(tempEvent.dateTime).format(
                      "YYYYMMDDTHHmmssZ"
                    ),
                    endDate: moment(tempEvent.dateTime)
                      .add(1, "hour")
                      .format("YYYYMMDDTHHmmssZ"),
                    description: event.description,
                    location: meetingUrl,
                  };
                  exportToGoogleCalendar(obj);
                }}
              >
                Add to calendar
              </Button>
            </Col>
          )}
          {scheduleExist === true && (
            <Col span={24} className="">
              <Button
                className="beam-btn orange-btn bordered w-full"
                onClick={() => {
                  if (id) {
                    dispatch(
                      DELETE_SCHEDULE({
                        eventId: id,
                        objectId: eventObj?.objectId,
                      })
                    );
                    handleCancel();
                  }
                }}
              >
                Remove
              </Button>
            </Col>
          )}
        </Row>
      )}
    </Modal>
  );
};

export default AddEventModal;
